import { render, staticRenderFns } from "./MenuPageListPanel.vue?vue&type=template&id=dcad0530&scoped=true&"
import script from "./MenuPageListPanel.vue?vue&type=script&lang=js&"
export * from "./MenuPageListPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuPageListPanel.vue?vue&type=style&index=0&id=dcad0530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcad0530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
